// extracted by mini-css-extract-plugin
export var backdrop = "_ie-1";
export var dragging = "_ie-4";
export var handle = "_ie-6";
export var handleHit = "_ie-5";
export var listEnd = "_ie-8";
export var modalRoot = "_ie-0";
export var sectionHeader = "_ie-a";
export var sheet = "_ie-3";
export var sheetHost = "_ie-2";
export var shortcutColumns = "_ie-7";
export var shortcutSection = "_ie-9";